module.exports = __webpack_public_path__ + "img/type10080.603e9600.png";